import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../../axios";
import Search from "../search/Search";
import ReactPaginate from "react-paginate";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";

const MisioniVizioni = () => {
  const [misionidata, setmisionidata] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const productsPerPage = 8;
  const productsPerList = 50;
  const pagesVisited = pageNumber * productsPerPage;
  let displayaboutusdata = [];
  const pageCount = Math.ceil(filtered.length / productsPerPage);

  const changePage = ({ selected }) => {
    // console.log(selected);
    setPageNumber(selected);
  };

  useEffect(() => {
    axios
      .get("misionvision/all")
      .then((res) => {
        setmisionidata(res?.data);
        setFiltered(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error("Something went wrong!");
        console.log(err);
      });
  }, []);

  return (
    <div className="misioni_vizioni text-left ">
      <div className="page-title ">
        <h1>Mission and Vision Management</h1>
      </div>
      <div className="row ml-n4 search">
        <div className="col-md-9">
          <Search
            data={misionidata}
            title="MisionAndVision"
            filtered={setFiltered}
            setPageNumber={setPageNumber}
          />
        </div>
        <div className="col-md-3">
          <Link to="/misionidhevizioni/add" className="myButton">
            Add New
          </Link>
        </div>
      </div>
      {/* <div className="row">
      <Link to="/aboutus/add" className="myButton">
        Add New
      </Link>
    </div> */}
      <div className="listimi-tabela">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="listimi-head">
              <div className="row ">
                <div className="col-1">ID</div>
                <div className="col-6">Misioni</div>
                {/* <div className="col-2">Translations :</div> */}
                <div className="col-1">ALB</div>
                <div className="col-1">SRB</div>
                <div className="col-1">ENG</div>
                {/* <div className='col-1'>{filtered.def_lang} </div> */}

                <div className="col-1 hideme"> </div>
                {/* <div className='col-1 hideme'> </div> */}
              </div>
            </div>{" "}
            {
              (displayaboutusdata = filtered
                ?.slice(pagesVisited, pagesVisited + productsPerPage)
                ?.map((filtered) => {
                  return (
                    <div className="listimi showme" key={filtered.id}>
                      <div className="row ">
                        <div className="col-1">{filtered.id} </div>
                        <div className="col-6">
                          {/* {filtered.content_al.slice(0, 50)} */}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: filtered?.content_al.slice(0, 50)+"...",
                            }}
                          ></div>
                        </div>

                        <div className="col-1">
                          {filtered.content_al === null ||
                            filtered.content_al === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}{" "}
                        </div>

                        <div className="col-1">
                          {filtered.content_sr === null ||
                            filtered.content_sr === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}{" "}
                        </div>

                        <div className="col-1">
                          {filtered.content_en === null ||
                            filtered.content_en === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}{" "}
                        </div>

                        {/* <div className='col-1'>{filtered.def_lang} </div> */}
                        <div className="col-1 delete">
                          <Link
                            className={"fa fa-trash"}
                            to={"/misionidhevizioni/delete/" + filtered.id}
                          ></Link>
                        </div>
                        <div className="col-1 edit">
                          <Link
                            className={"fa fa-edit"}
                            to={"/misionidhevizioni/edit/" + filtered.id}
                          ></Link>
                        </div>
                      </div>
                    </div>
                  );
                }))
            }
          </>
        )}
      </div>
      <div className="row mt-5">
        <div className="col-12">
          {misionidata.length >= productsPerPage ? (
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"previousBttn"}
              nextLinkClassName={"nextBttn"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default MisioniVizioni;
